import { useEffect } from 'react';
import { useNavigate, Outlet, useMatch } from 'react-router-dom';
import { Tabs, PermissionDenied, PermissionEnum, IconLoader } from '@ui/src';
import { useAppSelector } from '@store';
import ROUTES from '../../routes';
import {
  useLazyGetEmployeesBaseDictionariesQuery,
  useLazyGetActiveCurrenciesQuery,
  useLazyGetAdministrationCountriesQuery,
} from '../../store/dictionaries/service';
import { useLazyGetPSPDetailsValidatorsQuery } from './store/services/details';

import cn from './styles.module.css';

const SettingsPage = (): React.JSX.Element => {
  const navigate = useNavigate();

  const match = useMatch(ROUTES.OTHER_SETTINGS);

  const {
    administrationDictionaries: {
      activePermissions,
      roles,
      activeCurrencies,
      countries,
    },
    settings: {
      details: { pspDetails },
    },
  } = useAppSelector((state) => state);

  const [getEmployeesBaseDictionaries] =
    useLazyGetEmployeesBaseDictionariesQuery();
  const [getActiveCurrencies] = useLazyGetActiveCurrenciesQuery();
  const [getEmployeesCountries] = useLazyGetAdministrationCountriesQuery();
  const [getPspDetails] = useLazyGetPSPDetailsValidatorsQuery();

  useEffect(() => {
    if (
      match &&
      activePermissions?.includes(PermissionEnum.SETTINGS_SYSTEM_LIST)
    ) {
      navigate(ROUTES.CARDS);

      if (!roles) {
        getEmployeesBaseDictionaries();
      }

      if (!countries) {
        getEmployeesCountries();
      }

      if (!activeCurrencies) {
        getActiveCurrencies();
      }

      if (!pspDetails) {
        getPspDetails();
      }
    }
  }, [match, activePermissions, roles, countries, activeCurrencies]);

  useEffect(() => {
    let title = 'Settings';

    const companyName = localStorage.getItem('companyName');

    if (companyName) {
      title = `${title} | ${companyName}`;
    }

    document.title = title;
  }, []);

  let content = (
    <div className={cn.settingsLoader}>
      <IconLoader />
    </div>
  );

  if (activePermissions) {
    if (
      !activePermissions.includes(PermissionEnum.SECTION_ADMINISTRATION) ||
      !activePermissions.includes(PermissionEnum.SETTINGS_SYSTEM_LIST)
    ) {
      content = <PermissionDenied />;
    } else {
      content = (
        <div className={cn.settings}>
          <div className={cn.settingsTitle}>Other Settings</div>
          <div className={cn.settingsTabWrapper}>
            <Tabs
              itemClassName={cn.settingsTabItem}
              tabs={[
                {
                  name: 'Cards',
                  path: ROUTES.CARDS,
                },
                {
                  name: 'Top Up',
                  path: ROUTES.TOP_UP,
                },
                {
                  name: 'Statement',
                  path: ROUTES.STATEMENT,
                },
              ]}
              enableRouting
            />
          </div>
          <Outlet />
        </div>
      );
    }
  }

  return content;
};

export default SettingsPage;
